import type { BleConnectionStatus } from "@/types/device"

interface BleStatusIndicatorProps {
  status: BleConnectionStatus
}

export function BleStatusIndicator({ status }: BleStatusIndicatorProps) {
  const getStatusConfig = () => {
    switch (status) {
      case "connected":
        return {
          label: "Connected",
          dotColor: "bg-green-500",
          pingColor: "bg-green-400",
          textColor: "text-green-600",
        }
      case "connecting":
        return {
          label: "Connecting...",
          dotColor: "bg-yellow-500",
          pingColor: "bg-yellow-400",
          textColor: "text-yellow-600",
        }
      case "scanning":
        return {
          label: "Scanning...",
          dotColor: "bg-blue-500",
          pingColor: "bg-blue-400",
          textColor: "text-blue-600",
        }
      case "error":
        return {
          label: "Error",
          dotColor: "bg-red-500",
          pingColor: "bg-red-400",
          textColor: "text-red-600",
        }
      default:
        return {
          label: "Disconnected",
          dotColor: "bg-red-500",
          pingColor: "bg-red-400",
          textColor: "text-red-600",
        }
    }
  }

  const config = getStatusConfig()

  return (
    <div className="flex items-center gap-1.5">
      <span className="relative flex size-2">
        <span
          className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${config.pingColor}`}
        />
        <span
          className={`relative inline-flex size-2 rounded-full ${config.dotColor}`}
        />
      </span>
      <span className={`text-xs ${config.textColor}`}>{config.label}</span>
    </div>
  )
}
